import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('formulationReviewModal');

    return {
        AGRIAN_SOURCE: t('agrianSource'),
        CANCEL_BUTTON: t('cancelButton'),
        CLEAR_BUTTON: t('clearButton'),
        CLOSE_BUTTON: t('closeButton'),
        CONFIRM_BUTTON: t('confirmButton'),
        CURRENT_FORMULATION: t('currentFormulation'),
        DOCUMENT_ERROR: t('documentError'),
        EVIDENCE_HELPER: t('evidenceHelper'),
        EVIDENCE_LABEL: t('evidenceLabel'),
        LOADING: t('loading'),
        MENTIONS_PRODUCT: t('mentionsProduct'),
        MIXING_INSTRUCTIONS: t('mixingInstructions'),
        MIXING_NOTE_LABEL: t('mixingNoteLabel'),
        NO_CODE: t('noCode'),
        NO_STATEMENTS: t('noStatements'),
        OPEN_DOCUMENT: t('openDocument'),
        READ_ONLY: t('readOnly'),
        RETRY_BUTTON: t('retryButton'),
        SELF_STATEMENT: t('selfStatement'),
        SOURCE_SEPARATOR: t('sourceSeparator'),
        TITLE: t('title'),
        UNKNOWN: t('unknown'),
        UNKNOWN_SOURCE: t('unknownSource'),
        VERIFIED_SOURCE: t('verifiedSource'),
        contradiction: (codes: string): string => t('contradiction', { codes }),
        verifiedOn: (date: string): string => t('verifiedOn', { date })
    };
};

export default useTranslation;
